export enum ClassifierUrl {
  CLASSIFIER = '/classifiers{/id}{?page,size,sort*,search,selectedClassifier,code,name,description,validPeriod,validFrom,validTo,inUse,hasCategories}',
  CLASSIFIER_UPLOAD = '/classifiers/upload-excel',
  CLASSIFIER_WITH_GROUPS = '/classifiers/with-groups',
  ALL_CLASSIFIER_CATEGORIES = '/classifiers/all-categories/{classifierCode}{?categoryType,categoryGroupOrCombinedGroupCode,levelNumber}',
  SEARCH_CATEGORIES = '/classifiers/search-categories-and-groups{?searchText,classifierId,classifierCode,page,size}',
}
